import React from "react";

/**
 * Lovable / Radix-style hover tooltip for post detail header actions.
 */
export const PostDetailTooltip = ({
  label,
  description,
  side = "bottom",
  hidden = false,
  children,
}) => (
  <span
    className={[
      "post-detail-tooltip",
      `post-detail-tooltip--${side}`,
      hidden && "post-detail-tooltip--hidden",
    ]
      .filter(Boolean)
      .join(" ")}
  >
    {children}
    <span className="post-detail-tooltip__content" role="tooltip">
      <span className="post-detail-tooltip__label">{label}</span>
      {description ? (
        <span className="post-detail-tooltip__description">{description}</span>
      ) : null}
    </span>
  </span>
);

export default PostDetailTooltip;
